import { Component, OnInit } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';

@Component({
  selector: 'formly-repeat-section',
  template: `
    <div *ngFor="let field of field.fieldGroup; let i = index;">
      <formly-field [field]="field"></formly-field>
    </div>
    <div>
      <button
        mat-flat-button
        color="primary"
        (click)="add()"
        data-cy="borrower-status-reason-save"
      >{{props.addText}}</button>
    </div>
  `,
  standalone: false
})
export class RepeatSectionTypeComponent extends FieldArrayType implements OnInit {
    ngOnInit() {
        this.props.add = this.add.bind(this);
        this.props.remove = this.remove.bind(this);
      }
}
